/**
 * Needs to be reworked
 * @deprecated
 */

import { ProvideNames } from '#shared/statics';
import type { MenuLink } from "~~/models/Navigation";
import { getExpArticle } from "./expArticle";
import type { MediumData } from "@expert/types";

/**
 * Checks the state of the param
 *
 * @date 10.7.2023 - 19:42:21
 *
 * @param {*} param
 * @throws {Error} @if @param undefined
 */
function checkState(param: any) {
	if (param === undefined) {
		console.error("got undefined param", new Error().stack);
		throw new Error("Param was undefined");
	}
}
/**
 * Description placeholder
 * @date 10.7.2023 - 19:42:21
 *
 * @export
 * @async
 * @returns {unknown}
 */
export async function getAllExpManufacturers() {
	return useLazyFetch(useRuntimeConfig().public.apiUrl + "/api/neo/article-service/getAllManufacturers", {
		method: "POST",
		key: "allmanufacturers",
		body: {},
	});
}

const defaultImage: MediumData = {
	id: "default",
	mediumType: "Image",
	originalData: ProvideNames.PLACEHOLDER_IMAGE,
	name: "default Store Logo",
	alt: "default Store Logo",
	title: "default Store Logo",
};

/**
 * Fetch Medium Data by ID from Cache First
 * @date 10.7.2023 - 19:42:21
 *
 * @export
 * @async
 * @param {string} mediumId
 * @returns {any}
 */
export const getMedium = async (mediumId: string): Promise<{ data: Ref<MediumData | undefined>, pending: Ref<boolean> }> => {
	checkState(mediumId);

	const cached = useNuxtData<MediumData>("medium/id=" + mediumId);
	if (cached?.data?.value) {
		return {
            ...cached,
            pending: ref(false),
        };
	} else {
		return useFetch<MediumData>(useRuntimeConfig().public.apiUrl + "/api/medium/" + mediumId, {
			key: "medium/id=" + mediumId,
		});
	}
}


/**
 * Description placeholder
 * @date 24.8.2023 - 09:28:58
 *
 * @export
 * @deprecated
 * @returns {DealOfTheWeek}
 */
export function getDealOfTheWeek() {
	return useLazyFetch(
		useRuntimeConfig().public.apiUrl + "/api/nea/dotw/get",
		{
			transform(data) {
				let mapped = data;
				if (mapped?.imageSource) mapped.imageSource = mapped.imageSource.replace("https://cdn.expert.de/cdn-cgi/image/format=auto", "");
				if (mapped?.backgroundImageSource)
					mapped.backgroundImageSource = mapped.backgroundImageSource.replace("https://cdn.expert.de/cdn-cgi/image/format=auto", "");

				// console.debug("[bt-cache] handling deal of the week response (raw,mapped)", data, mapped);
				return mapped;
			}
		},
	);
}

/**
 * Returns and handles the caching of the Navigation Tree for the MegaMenu Component
 * @param storeId
 * @returns {Navigation}
 */
const doFilter = true;
/**
 * Description placeholder
 * @date 10.7.2023 - 19:42:21
 *
 * @export
 * @async
 * @param {string} storeId
 * @param {?string} [navigationName]
 */
export const getExpNavigationTree = (navigationName?: string) => { return { data: useState<Array<MenuLink>>('navigation_tree' + (navigationName || 'MAIN')) } }

export const fetchNavigationTree = async (navigationName?: string) => {
	const tag = navigationName || 'MAIN';
    const baseUrl = import.meta.client ? useRuntimeConfig().public.apiUrl : '';
    const apiUrl = `${baseUrl}/api/navigation`
    useLogger('debug').error(`Navi Url: ${apiUrl}`)
	return $fetch<Array<MenuLink>>(apiUrl, {
		query: {
			tag: tag,
			storeId: useCurrentStoreId(),
		},
	});
}

export const getOrFetchExpNavigationTree = async (navigationName?: string): Promise<Array<MenuLink>> => {
	const { data: navigationData } = getExpNavigationTree(navigationName);
	if (navigationData.value) {
		return navigationData.value;
	} else {
		return await fetchNavigationTree(navigationName);
	}
};

/**
 * Recursively Sorts the Tree
 * @date 10.7.2023 - 19:42:21
 *
 * @param {*} cat
 */
export function recursiveSort(cat: any) {
	if (cat && cat.descendants && Array.isArray(cat.descendants)) {
		cat.descendants.sort((a: { position: number }, b: { position: number }) => b.position - a.position);
		cat.descendants?.forEach((desc: any) => recursiveSort(desc));
	}
}

/**
 * Description placeholder
 * @date 10.7.2023 - 19:42:21
 *
 * @export
 * @async
 * @param {string} articleId
 * @returns {unknown}
 */
export function getExpertArticle(articleId: string) {
	return getExpArticle(articleId);
}

export function getExpBrand(brandId: string) {
	const cached = useNuxtData("brand/id=" + brandId);

	if (cached?.data?.value) {
		// console.debug("[expCache] returning cached Brand " + brandId);
		return cached;
	}
	// console.debug("[expCache] fetching fresh Brand " + brandId);
	return useLazyFetch(useRuntimeConfig().public.apiUrl + "/api/neo/article/brand/" + brandId, {
		key: "brand/id=" + brandId,
	});
}
/**
 * Description placeholder
 * @date 10.7.2023 - 19:42:21
 *
 * @export
 * @async
 * @param {string} manufacturerId
 * @returns {unknown}
 */
export async function getExpManufacturer(manufacturerId: string) {
	// console.log("expCache getExpManufacturer : "+manufacturerId)
	return useLazyFetch(useRuntimeConfig().public.apiUrl + "/api/neo/article-service/getManufacturer", {
		method: "POST",
		key: "manufacturer-" + manufacturerId,
		body: {
			manufacturerId: manufacturerId,
		},
	});
}

const expManufacturers: Record<string, ReturnType<typeof useFetch> | undefined> = {};
export const getExpManufacturerByBrandId = async (brandId: string) => {
	if(expManufacturers[brandId]) return expManufacturers[brandId];
	const response = useNuxtData(`manufacturer/byBrand=${brandId}`);
	if (response?.data?.value) {
		return response;
	}

	expManufacturers[brandId] = useFetch(useRuntimeConfig().public.apiUrl + '/api/neo/article/manufacturers/' + brandId, {
		key: `manufacturer/byBrand=${brandId}`,
	});
	return expManufacturers[brandId];
}

/**
 * bust the chache
 * @date 10.7.2023 - 19:42:21
 *
 * @export
 * @param {string} prefix
 * @returns {*}
 */
export function bustCache(prefix: string) {
	if (prefix === "*") {
		console.debug("clearing local cache");
		// nuxtStorage.localStorage?.clear();
	}
}
